import { WithChildren } from '../../../core/types/with-children.js';
import { useGridPlotSize } from '../../core/components/chart-grid/hooks/useGridPlotSize.js';
import { XYChartScalesContext } from '../context/XYChartScales.context.js';
import { useXYChartData } from '../hooks/useXYChartData.js';
import { useCurrentDomainState } from '../store/selectors.js';
import { generateScalesByAxisId } from '../utils/generate-scales-by-axis-id.js';

export const XYChartScalesProvider = ({ children }: WithChildren) => {
  const { width, height } = useGridPlotSize();
  const zoomedDomainScaleMap = useCurrentDomainState();
  const {
    axisIdToScaleDomain: initialDomainScaleMap,
    axes,
    axisIdToDimension,
  } = useXYChartData();

  const axisIdToScales = generateScalesByAxisId(
    axes,
    initialDomainScaleMap,
    zoomedDomainScaleMap,
    axisIdToDimension,
    width,
    height,
  );

  return (
    <XYChartScalesContext.Provider value={axisIdToScales}>
      {children}
    </XYChartScalesContext.Provider>
  );
};

XYChartScalesProvider['displayName'] = 'XYChartScaleProvider';
